import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2095bed4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-data" }
const _hoisted_2 = { class: "report-tenant" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Tenant", -1))
const _hoisted_4 = { class: "value" }
const _hoisted_5 = { class: "report-reference" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Mês de Referência", -1))
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "report-due" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Vencimento", -1))
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "report-status" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Status", -1))
const _hoisted_13 = { class: "value" }
const _hoisted_14 = {
  key: 0,
  class: "paid"
}
const _hoisted_15 = {
  key: 1,
  class: "not-paid"
}
const _hoisted_16 = { class: "report-sensors" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Sensores", -1))
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "report-sensor-value" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Custo por Sensor", -1))
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { class: "report-value" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Valor Total", -1))
const _hoisted_24 = { class: "value" }
const _hoisted_25 = {
  key: 0,
  class: "report-pay"
}
const _hoisted_26 = { class: "icon" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Pagar", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.tenant.name), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.convertToLocalMonthYear(_ctx.report.referenceDate)), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.convertToLocalDate(_ctx.report.dueDate)), 1)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("span", _hoisted_13, [
        (_ctx.report.paid)
          ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Pago"))
          : (_openBlock(), _createElementBlock("span", _hoisted_15, "Aguardando Pagamento"))
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _hoisted_17,
      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.report.sensors.length), 1)
    ]),
    _createElementVNode("div", _hoisted_19, [
      _hoisted_20,
      _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.numberToLocalCurrency(_ctx.report.valuePerSensor)), 1)
    ]),
    _createElementVNode("div", _hoisted_22, [
      _hoisted_23,
      _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.numberToLocalCurrency(_ctx.report.valueTotal)), 1)
    ]),
    (!_ctx.isMaster && !_ctx.report.paid)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createElementVNode("button", {
            class: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.pay(_ctx.report)))
          }, [
            _createElementVNode("span", _hoisted_26, [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-cart-shopping" })
            ]),
            _hoisted_27
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}